'use strict';

const {createEnum} = require('../../../utils/enum');

/**
 * Enum class representing a "type" of a carousel page change. Mostly useful for GA tracking purposes.
 */
module.exports = createEnum('next', 'previous', 'jump');



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/utils/pageChangeTypeEnum.es.js